import axios from "axios";

export const getPrayerTime = () => {
  let endPoint =
    "https://api.aladhan.com/v1/timingsByCity?city=Tashkent&country=Uzbekistan&method=2&school=1";

  return axios.get(endPoint);
};
